"use strict";

export class Delayer { 
    constructor(layers,callback) {
        this._callback = callback;
        this._layers = [];
        for (let i = 0; i < layers; i++) {
            this._layers.push(false);
        }
    }

    get validated() {
        return this.validations == this._layers.length;
    }
    get validations() {
        let result = 0;
        this._layers.forEach(layer => result += layer ? 1 : 0);
        return result;
    }

    validate(index) {
        this._layers[index] = true;

        for (let i = 0; i < this._layers.length; i++) {
            if (!this._layers[i]) return;
        }

        this._callback?.();
    }

    reset() {
        for (let i = 0; i < this._layers.length; i++) {
            this._layers[i] = false;
        }
    }
}